export default __webpack_public_path__ + "static/media/smoke.43c23bee.svg";